





















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import * as _ from "lodash";
import { GetFuwurenci } from "@/request/hdr";
import TimeSelect from "../time-type-select.vue";
import axios, { resHandle } from "@/plugins/axios";

@Component({
  components: {
    TimeSelect,
  },
})
export default class HdrAnalysisReportFuwurenci extends Vue {
  @Prop()
  private selectedHospitals: any;
  @Prop()
  private allHospitals: any;
  private message: any = {
    title: [],
    data: [],
    count: {},
  };
  private cYear: number = new Date().getFullYear();
  private loaded: boolean = false;
  private yuequshi: any = {
    tooltip: {
      show: true,
      trigger: "item",
    },
    grid: {
      left: "5%",
      right: "2%",
      top: "40",
      bottom: "40",
    },
    xAxis: {
      type: "category",
      axisLabel: {
        color: "rgba(0,0,0,0.45)",
      },
      axisLine: {
        lineStyle: {
          color: "rgba(0,0,0,0.45)",
        },
      },
    },
    yAxis: {
      type: "value",
      axisLine: {
        show: false,
      },
    },
    series: [
      {
        type: "bar",
        data: [],
        itemStyle: {
          color: "#6C99F6",
        },
      },
    ],
  };
  private get years() {
    const arr: any = [];
    const currentYear = new Date().getFullYear();
    Array.of(0, 1, 2, 3, 4).forEach((i: any) => {
      arr.push(currentYear - i);
    });
    return arr;
  }
  /**
   * @description 获取服务人次数据
   */
  private fuwurenci() {
    const ids: any = [];
    const reg: RegExp = /^doctor\_id\_(.*)/;
    console.log(this.selectedHospitals);
    if (this.selectedHospitals.length === 0) {
      this.allHospitals.forEach((h: any) => {
        const result = reg.exec(h.hospital_id);
        // console.log(result);
        if (result) {
          ids.push(result[1]);
        }
      });
    } else {
      this.selectedHospitals.forEach((h: any) => {
        const result = reg.exec(h.hospital_id);
        // console.log(result);
        if (result) {
          ids.push(result[1]);
        }
      });
    }
    const params: any = {
      params: {
        year: this.cYear,
      },
    };
    if (ids.length > 0) {
      params.params["doctorIds"] = ids.join(",");
    } else {
      params.params["doctorIds"] = "999999";
    }
    GetFuwurenci(this, params)
      .then((data: any) => {
        console.log(data);
        this.message.title = [
          "一月",
          "二月",
          "三月",
          "四月",
          "五月",
          "六月",
          "七月",
          "八月",
          "九月",
          "十月",
          "十一月",
          "十二月",
        ];
        this.message.data = [
          {
            value: data.data["janCount"],
            name: "一月",
          },
          {
            value: data.data["febCount"],
            name: "二月",
          },
          {
            value: data.data["marCount"],
            name: "三月",
          },
          {
            value: data.data["aprCount"],
            name: "四月",
          },
          {
            value: data.data["mayCount"],
            name: "五月",
          },
          {
            value: data.data["junCount"],
            name: "六月",
          },
          {
            value: data.data["julCount"],
            name: "七月",
          },
          {
            value: data.data["augCount"],
            name: "八月",
          },
          {
            value: data.data["septCount"],
            name: "九月",
          },
          {
            value: data.data["octCount"],
            name: "十月",
          },
          {
            value: data.data["novCount"],
            name: "十一月",
          },
          {
            value: data.data["decCount"],
            name: "十二月",
          },
        ];
        this.message.count = {
          totalCount: data.data["totalCount"],
          monthCount: data.data["monthCount"],
          dayCount: data.data["dayCount"],
        };
        this.createYuequshi();
      })
      .catch(() => {
        console.log("err");
      });
  }
  /**
   * @description 月趋势年份改变
   */
  private yearChange(year) {
    this.cYear = year;
    this.fuwurenci();
  }
  /**
   * @description 创建月趋势图
   */
  private createYuequshi() {
    this.yuequshi.series[0].data = this.message["data"];
    this.yuequshi.xAxis.data = this.message["title"];
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.$watch(
      () => {
        return this.selectedHospitals;
      },
      () => {
        this.fuwurenci();
      },
      {
        immediate: true,
      }
    );
  }
}
